<template>
  <div>
    <div slot="title">
      <h2> Personal Evaluado</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row">
          <div class="col-3"><h5>Buscar Personal</h5></div>
        </div>
        <div class="row">
          <div class="col-3">
            <input type="text" class="form-control" placeholder="Nombre" />
          </div>
          <div class="col-3">
            <input type="text" class="form-control" placeholder="No. de Nómina" />
          </div>
          <div class="col-1">
            <input type="checkbox" class="form-control" />
          </div>
          <div class="col-2">
            <h5><span class="label label-default">Tipo de Puesto</span></h5>
          </div>
        </div>
        <div class="row">
          <div class="col-6"></div>
          <div class="col-3"><hr /></div>
        </div>
        <div class="row">
          <div class="col-6"></div>
          <div class="col-1">
            <input type="checkbox" class="form-control" />
          </div>
          <div class="col-2">
            <h5><span class="label label-default">Interinato</span></h5>
          </div>
        </div>
        <div class="row">
          <div class="col-6"></div>
          <div class="col-1">
            <input type="checkbox" class="form-control" />
          </div>
          <div class="col-2">
            <h5><span class="label label-default">Base</span></h5>
          </div>
        </div>
        <div class="row">
          <div class="col-9"></div>
          <div class="col-2"><input type="button" value="Buscar" class="form-control" /></div>
        </div>
        <div class="row">
          <div class="col-12"><hr /></div>
        </div>
        <div class="row">
          <div class="col-5">
            <h5><span class="label label-default">Resultado de la búsqueda</span></h5>
          </div>
          <div class="col-4">
            <input type="text" placeholder="Buscar.." name="search" class="form-control">
          </div>
          <div class="col-1 text-left">
            <button type="submit" class="form-control"><i class="fa fa-search"></i></button>
          </div>
        </div><br>
        <div class="row">
          <div class="col-10">
            <table class="table table-striped table-light table-hover">
              <thead class="thead-custom">
                <tr>
                  <th>ID Evaluado</th>
                  <th>Nombre</th>
                  <th>Puesto</th>
                  <th>Tipo Puesto</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody class="text-dark">
                <tr>
                  <td>12</td>
                  <td>José María Pérez Pérez</td>
                  <td>Director de Ejecutores</td>
                  <td>Interinato</td>
                  <td><i class="fa fa-info-circle" /></td>
                </tr>
                <tr>
                  <td>43</td>
                  <td>Francisco Macías López</td>
                  <td>Director de Informática</td>
                  <td>Interinato</td>
                  <td><i class="fa fa-info-circle" /></td>
                </tr>
                <tr>
                  <td>29</td>
                  <td>María Serna</td>
                  <td>Director de Psicología</td>
                  <td>Base (Confianza)</td>
                  <td><i class="fa fa-info-circle" /></td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //import Layout from '@/components/SIAP/Comun/Plantilla.vue';
  import catalogos from '@/../static/js/catalogos'
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {

      }
    },
    components: {
      //Layout
    },
    methods: {

    }

  }

</script>

<style scoped>
  .thead-custom {
    background-color: #004746;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/SIAP/Evaluaciones/PersonalEvaluado.vue